import { CURRENT_PHASE, formatVersion, shortSha } from '@personal-os/shared';

export const webVersion = formatVersion({ phase: CURRENT_PHASE, sha: shortSha(__GIT_SHA__) });
